/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
import { ReactElement } from 'react'

export default function DraggableIcon(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none" {...props}>
      <circle cx="1" cy="1" r="1" fill="currentColor" />
      <circle cx="1" cy="5" r="1" fill="currentColor" />
      <circle cx="1" cy="9" r="1" fill="currentColor" />
      <circle cx="5" cy="1" r="1" fill="currentColor" />
      <circle cx="5" cy="5" r="1" fill="currentColor" />
      <circle cx="5" cy="9" r="1" fill="currentColor" />
    </svg>
  )
}
